import * as React from 'react';
import EditRoadIcon from '@mui/icons-material/EditRoad';

import { Typography } from '@mui/material';

export default function NotificacionPage() {
  return (

    <div
      style={{
        height: '100%',
        display: "flex",
        width: '100%',
        backgroundColor: "#f6f6f6",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ flexDirection: 'row', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <EditRoadIcon style={{ marginLeft: 10, marginBottom: 10, color: 'rgba(229, 29, 29, 0.7)' }} />
        <h3 style={{ color: 'rgba(229, 29, 29, 0.7)', alignSelf: 'flex-start', marginLeft: 15, marginBottom: 10 }}>
          Notificaciones
        </h3>

      </div>

      <div
        style={{
          height: 'auto',
          display: "flex",
          width: '100%',
          backgroundColor: 'rgba(238, 238, 238, 0.9)',
          marginTop: 10,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* <Box sx={{ flexGrow: 1, width: '100%', height: '100%', }}>
          <Grid container spacing={2} columns={10}>

            <Grid item xs={10}>
              <Item>
                <Table sx={{ maxWidth: '100%', overflow: 'auto', }} aria-label="customized table">
                  <TableRow style={{ backgroundColor: 'lightgrey', color: '#000', fontWeight: 600, }}>

                    <TableCell align="left">Tipo de Solicitud</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                    <TableCell align="right">Fecha</TableCell>

                  </TableRow>
                </Table>

                <ListReport data={data} />

              </Item>
            </Grid>


          </Grid>
        </Box> */}
        <Typography>
          Esta sección se encuentra en construcción.
        </Typography>

      </div>

    </div >

  );
}
